/**
 * string-remove-widows
 * Helps to prevent widow words in a text
 * Version: 1.6.17
 * Author: Roy Revelt, Codsen Ltd
 * License: MIT
 * Homepage: https://codsen.com/os/string-remove-widows/
 */
!function (t, r) {
  "object" == typeof exports && "undefined" != typeof module ? r(exports) : "function" == typeof define && define.amd ? define(["exports"], r) : r((t = "undefined" != typeof globalThis ? globalThis : t || self).stringRemoveWidows = {});
}(this, function (t) {
  "use strict";

  function r(t) {
    return (r = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (t) {
      return typeof t;
    } : function (t) {
      return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
    })(t);
  }

  function e(t, r) {
    for (var e = 0; e < r.length; e++) {
      var n = r[e];
      n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(t, n.key, n);
    }
  }

  function n(t, r, e) {
    return r in t ? Object.defineProperty(t, r, {
      value: e,
      enumerable: !0,
      configurable: !0,
      writable: !0
    }) : t[r] = e, t;
  }

  function o(t, r) {
    var e = Object.keys(t);

    if (Object.getOwnPropertySymbols) {
      var n = Object.getOwnPropertySymbols(t);
      r && (n = n.filter(function (r) {
        return Object.getOwnPropertyDescriptor(t, r).enumerable;
      })), e.push.apply(e, n);
    }

    return e;
  }

  function i(t) {
    for (var r = 1; r < arguments.length; r++) {
      var e = null != arguments[r] ? arguments[r] : {};
      r % 2 ? o(Object(e), !0).forEach(function (r) {
        n(t, r, e[r]);
      }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(e)) : o(Object(e)).forEach(function (r) {
        Object.defineProperty(t, r, Object.getOwnPropertyDescriptor(e, r));
      });
    }

    return t;
  }

  function a(t) {
    return function (t) {
      if (Array.isArray(t)) return s(t);
    }(t) || function (t) {
      if ("undefined" != typeof Symbol && Symbol.iterator in Object(t)) return Array.from(t);
    }(t) || function (t, r) {
      if (!t) return;
      if ("string" == typeof t) return s(t, r);
      var e = Object.prototype.toString.call(t).slice(8, -1);
      "Object" === e && t.constructor && (e = t.constructor.name);
      if ("Map" === e || "Set" === e) return Array.from(t);
      if ("Arguments" === e || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(e)) return s(t, r);
    }(t) || function () {
      throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }();
  }

  function s(t, r) {
    (null == r || r > t.length) && (r = t.length);

    for (var e = 0, n = new Array(r); e < r; e++) {
      n[e] = t[e];
    }

    return n;
  }

  function u(t) {
    return "string" == typeof t ? t.length > 0 ? [t] : [] : t;
  }

  function c(t) {
    return t && "object" === r(t) && !Array.isArray(t);
  }

  function f(t) {
    return "string" == typeof t;
  }

  function l(t, r, e, n, o, i) {
    var a = "function" == typeof e ? e() : e;
    if (r < 0 && o && "EOL" === a) return a;
    if (r >= t.length && !o) return !1;

    for (var s = o ? 1 : e.length, u = !1, c = !1, f = n.maxMismatches, l = r, g = !1, h = !1, p = !1; t[l];) {
      var y = i(l);

      if (n.trimBeforeMatching && "" === t[l].trim()) {
        if (!t[y] && o && "EOL" === e) return !0;
        l = i(l);
      } else if (!n.i && n.trimCharsBeforeMatching.includes(t[l]) || n.i && n.trimCharsBeforeMatching.map(function (t) {
        return t.toLowerCase();
      }).includes(t[l].toLowerCase())) {
        if (o && "EOL" === e && !t[y]) return !0;
        l = i(l);
      } else {
        var m = y > l ? e[e.length - s] : e[s - 1];

        if (!n.i && t[l] === m || n.i && t[l].toLowerCase() === m.toLowerCase()) {
          if (g || (g = !0), c || (c = !0), s === e.length ? h = !0 : 1 === s && (p = !0), (s -= 1) < 1) return l;
        } else {
          if (!(n.maxMismatches && f && l)) return !(0 !== l || 1 !== s || n.lastMustMatch || !c) && 0;
          f -= 1;

          for (var d = 0; d <= f; d++) {
            var v = y > l ? e[e.length - s + 1 + d] : e[s - 2 - d],
                b = t[i(l)];

            if (v && (!n.i && t[l] === v || n.i && t[l].toLowerCase() === v.toLowerCase()) && (!n.firstMustMatch || s !== e.length)) {
              s -= 2, g = !0;
              break;
            }

            if (b && v && (!n.i && b === v || n.i && b.toLowerCase() === v.toLowerCase()) && (!n.firstMustMatch || s !== e.length)) {
              s -= 1, g = !0;
              break;
            }

            if (void 0 === v && f >= 0 && g && (!n.firstMustMatch || h) && (!n.lastMustMatch || p)) return l;
          }

          g || (u = l);
        }

        if (!1 !== u && u !== l && (u = !1), s < 1) return l;
        l = i(l);
      }
    }

    return s > 0 ? !(!o || "EOL" !== a) || !!(n.maxMismatches >= s && c) && (u || 0) : void 0;
  }

  function g(t, e, n, o) {
    return function (t, e, n, o, a) {
      var s = {
        cb: void 0,
        i: !1,
        trimBeforeMatching: !1,
        trimCharsBeforeMatching: [],
        maxMismatches: 0,
        firstMustMatch: !1,
        lastMustMatch: !1
      };
      if (c(a) && Object.prototype.hasOwnProperty.call(a, "trimBeforeMatching") && "boolean" != typeof a.trimBeforeMatching) throw new Error("string-match-left-right/".concat(t, "(): [THROW_ID_09] opts.trimBeforeMatching should be boolean!").concat(Array.isArray(a.trimBeforeMatching) ? " Did you mean to use opts.trimCharsBeforeMatching?" : ""));
      var g,
          h,
          p,
          y,
          m = i(i({}, s), a);
      if (m.trimCharsBeforeMatching = u(m.trimCharsBeforeMatching), m.trimCharsBeforeMatching = m.trimCharsBeforeMatching.map(function (t) {
        return f(t) ? t : String(t);
      }), !f(e)) return !1;
      if (!e.length) return !1;
      if (!Number.isInteger(n) || n < 0) throw new Error("string-match-left-right/".concat(t, "(): [THROW_ID_03] the second argument should be a natural number. Currently it's of a type: ").concat(r(n), ", equal to:\n").concat(JSON.stringify(n, null, 4)));
      if (f(o)) g = [o];else if (Array.isArray(o)) g = o;else if (o) {
        if ("function" != typeof o) throw new Error("string-match-left-right/".concat(t, "(): [THROW_ID_05] the third argument, whatToMatch, is neither string nor array of strings! It's ").concat(r(o), ", equal to:\n").concat(JSON.stringify(o, null, 4)));
        (g = []).push(o);
      } else g = o;
      if (a && !c(a)) throw new Error("string-match-left-right/".concat(t, "(): [THROW_ID_06] the fourth argument, options object, should be a plain object. Currently it's of a type \"").concat(r(a), '", and equal to:\n').concat(JSON.stringify(a, null, 4)));
      if (m.trimCharsBeforeMatching.some(function (t, r) {
        return t.length > 1 && (p = r, y = t, !0);
      })) throw new Error("string-match-left-right/".concat(t, "(): [THROW_ID_07] the fourth argument, options object contains trimCharsBeforeMatching. It was meant to list the single characters but one of the entries at index ").concat(p, " is longer than 1 character, ").concat(y.length, " (equals to ").concat(y, "). Please split it into separate characters and put into array as separate elements."));

      if (!g || !Array.isArray(g) || Array.isArray(g) && !g.length || Array.isArray(g) && 1 === g.length && f(g[0]) && !g[0].trim()) {
        if ("function" == typeof m.cb) {
          var d,
              v = n;
          if ("matchLeftIncl" !== t && "matchRight" !== t || (v += 1), "L" === t[5]) for (var b = v; b--;) {
            var w = e[b];

            if ((!m.trimBeforeMatching || m.trimBeforeMatching && void 0 !== w && w.trim()) && (!m.trimCharsBeforeMatching.length || void 0 !== w && !m.trimCharsBeforeMatching.includes(w))) {
              d = b;
              break;
            }
          } else if (t.startsWith("matchRight")) for (var _ = v; _ < e.length; _++) {
            var O = e[_];

            if ((!m.trimBeforeMatching || m.trimBeforeMatching && O.trim()) && (!m.trimCharsBeforeMatching.length || !m.trimCharsBeforeMatching.includes(O))) {
              d = _;
              break;
            }
          }
          if (void 0 === d) return !1;
          var T = e[d],
              j = d + 1,
              A = "";
          return j && j > 0 && (A = e.slice(0, j)), "L" === t[5] || d && d > 0 && (A = e.slice(d)), m.cb(T, A, d);
        }

        var I = "";
        throw a || (I = " More so, the whole options object, the fourth input argument, is missing!"), new Error("string-match-left-right/".concat(t, '(): [THROW_ID_08] the third argument, "whatToMatch", was given as an empty string. This means, you intend to match purely by a callback. The callback was not set though, the opts key "cb" is not set!').concat(I));
      }

      for (var E = 0, M = g.length; E < M; E++) {
        h = "function" == typeof g[E];
        var W = g[E],
            R = void 0,
            C = void 0,
            S = "",
            F = n;
        "matchRight" === t ? F += 1 : "matchLeft" === t && (F -= 1);
        var L = l(e, F, W, m, h, function (r) {
          return "L" === t[5] ? r - 1 : r + 1;
        });
        if (L && h && "function" == typeof W && "EOL" === W()) return !(!W() || m.cb && !m.cb(R, S, C)) && W();
        if (Number.isInteger(L) && (C = t.startsWith("matchLeft") ? L - 1 : L + 1, S = "L" === t[5] ? e.slice(0, L) : e.slice(C)), C < 0 && (C = void 0), e[C] && (R = e[C]), Number.isInteger(L) && (!m.cb || m.cb(R, S, C))) return W;
      }

      return !1;
    }("matchRightIncl", t, e, n, o);
  }

  var h,
      p,
      y = Function.prototype,
      m = Object.prototype,
      d = y.toString,
      v = m.hasOwnProperty,
      b = d.call(Object),
      w = m.toString,
      _ = (h = Object.getPrototypeOf, p = Object, function (t) {
    return h(p(t));
  });

  var O = function O(t) {
    if (!function (t) {
      return !!t && "object" == r(t);
    }(t) || "[object Object]" != w.call(t) || function (t) {
      var r = !1;
      if (null != t && "function" != typeof t.toString) try {
        r = !!(t + "");
      } catch (t) {}
      return r;
    }(t)) return !1;

    var e = _(t);

    if (null === e) return !0;
    var n = v.call(e, "constructor") && e.constructor;
    return "function" == typeof n && n instanceof n && d.call(n) == b;
  },
      T = "undefined" != typeof globalThis ? globalThis : "undefined" != typeof window ? window : "undefined" != typeof global ? global : "undefined" != typeof self ? self : {};

  !function (t, r, e) {
    t(e = {
      path: r,
      exports: {},
      require: function require(t, r) {
        return function () {
          throw new Error("Dynamic requires are not currently supported by @rollup/plugin-commonjs");
        }(null == r && e.path);
      }
    }, e.exports), e.exports;
  }(function (t, e) {
    var n = "__lodash_hash_undefined__",
        o = 9007199254740991,
        i = "[object Arguments]",
        a = "[object Boolean]",
        s = "[object Date]",
        u = "[object Function]",
        c = "[object GeneratorFunction]",
        f = "[object Map]",
        l = "[object Number]",
        g = "[object Object]",
        h = "[object Promise]",
        p = "[object RegExp]",
        y = "[object Set]",
        m = "[object String]",
        d = "[object Symbol]",
        v = "[object WeakMap]",
        b = "[object ArrayBuffer]",
        w = "[object DataView]",
        _ = "[object Float32Array]",
        O = "[object Float64Array]",
        j = "[object Int8Array]",
        A = "[object Int16Array]",
        I = "[object Int32Array]",
        E = "[object Uint8Array]",
        M = "[object Uint8ClampedArray]",
        W = "[object Uint16Array]",
        R = "[object Uint32Array]",
        C = /\w*$/,
        S = /^\[object .+?Constructor\]$/,
        F = /^(?:0|[1-9]\d*)$/,
        L = {};
    L[i] = L["[object Array]"] = L[b] = L[w] = L[a] = L[s] = L[_] = L[O] = L[j] = L[A] = L[I] = L[f] = L[l] = L[g] = L[p] = L[y] = L[m] = L[d] = L[E] = L[M] = L[W] = L[R] = !0, L["[object Error]"] = L[u] = L[v] = !1;
    var P = "object" == r(T) && T && T.Object === Object && T,
        D = "object" == ("undefined" == typeof self ? "undefined" : r(self)) && self && self.Object === Object && self,
        N = P || D || Function("return this")(),
        k = e && !e.nodeType && e,
        B = k && t && !t.nodeType && t,
        x = B && B.exports === k;

    function H(t, r) {
      return t.set(r[0], r[1]), t;
    }

    function J(t, r) {
      return t.add(r), t;
    }

    function q(t, r, e, n) {
      var o = -1,
          i = t ? t.length : 0;

      for (n && i && (e = t[++o]); ++o < i;) {
        e = r(e, t[o], o, t);
      }

      return e;
    }

    function $(t) {
      var r = !1;
      if (null != t && "function" != typeof t.toString) try {
        r = !!(t + "");
      } catch (t) {}
      return r;
    }

    function U(t) {
      var r = -1,
          e = Array(t.size);
      return t.forEach(function (t, n) {
        e[++r] = [n, t];
      }), e;
    }

    function z(t, r) {
      return function (e) {
        return t(r(e));
      };
    }

    function Z(t) {
      var r = -1,
          e = Array(t.size);
      return t.forEach(function (t) {
        e[++r] = t;
      }), e;
    }

    var K,
        V = Array.prototype,
        G = Function.prototype,
        Q = Object.prototype,
        X = N["__core-js_shared__"],
        Y = (K = /[^.]+$/.exec(X && X.keys && X.keys.IE_PROTO || "")) ? "Symbol(src)_1." + K : "",
        tt = G.toString,
        rt = Q.hasOwnProperty,
        et = Q.toString,
        nt = RegExp("^" + tt.call(rt).replace(/[\\^$.*+?()[\]{}|]/g, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$"),
        ot = x ? N.Buffer : void 0,
        it = N.Symbol,
        at = N.Uint8Array,
        st = z(Object.getPrototypeOf, Object),
        ut = Object.create,
        ct = Q.propertyIsEnumerable,
        ft = V.splice,
        lt = Object.getOwnPropertySymbols,
        gt = ot ? ot.isBuffer : void 0,
        ht = z(Object.keys, Object),
        pt = Bt(N, "DataView"),
        yt = Bt(N, "Map"),
        mt = Bt(N, "Promise"),
        dt = Bt(N, "Set"),
        vt = Bt(N, "WeakMap"),
        bt = Bt(Object, "create"),
        wt = $t(pt),
        _t = $t(yt),
        Ot = $t(mt),
        Tt = $t(dt),
        jt = $t(vt),
        At = it ? it.prototype : void 0,
        It = At ? At.valueOf : void 0;

    function Et(t) {
      var r = -1,
          e = t ? t.length : 0;

      for (this.clear(); ++r < e;) {
        var n = t[r];
        this.set(n[0], n[1]);
      }
    }

    function Mt(t) {
      var r = -1,
          e = t ? t.length : 0;

      for (this.clear(); ++r < e;) {
        var n = t[r];
        this.set(n[0], n[1]);
      }
    }

    function Wt(t) {
      var r = -1,
          e = t ? t.length : 0;

      for (this.clear(); ++r < e;) {
        var n = t[r];
        this.set(n[0], n[1]);
      }
    }

    function Rt(t) {
      this.__data__ = new Mt(t);
    }

    function Ct(t, e) {
      var n = zt(t) || function (t) {
        return function (t) {
          return function (t) {
            return !!t && "object" == r(t);
          }(t) && Zt(t);
        }(t) && rt.call(t, "callee") && (!ct.call(t, "callee") || et.call(t) == i);
      }(t) ? function (t, r) {
        for (var e = -1, n = Array(t); ++e < t;) {
          n[e] = r(e);
        }

        return n;
      }(t.length, String) : [],
          o = n.length,
          a = !!o;

      for (var s in t) {
        !e && !rt.call(t, s) || a && ("length" == s || Jt(s, o)) || n.push(s);
      }

      return n;
    }

    function St(t, r, e) {
      var n = t[r];
      rt.call(t, r) && Ut(n, e) && (void 0 !== e || r in t) || (t[r] = e);
    }

    function Ft(t, r) {
      for (var e = t.length; e--;) {
        if (Ut(t[e][0], r)) return e;
      }

      return -1;
    }

    function Lt(t, r, e, n, o, h, v) {
      var T;
      if (n && (T = h ? n(t, o, h, v) : n(t)), void 0 !== T) return T;
      if (!Gt(t)) return t;
      var S = zt(t);

      if (S) {
        if (T = function (t) {
          var r = t.length,
              e = t.constructor(r);
          r && "string" == typeof t[0] && rt.call(t, "index") && (e.index = t.index, e.input = t.input);
          return e;
        }(t), !r) return function (t, r) {
          var e = -1,
              n = t.length;
          r || (r = Array(n));

          for (; ++e < n;) {
            r[e] = t[e];
          }

          return r;
        }(t, T);
      } else {
        var F = Ht(t),
            P = F == u || F == c;
        if (Kt(t)) return function (t, r) {
          if (r) return t.slice();
          var e = new t.constructor(t.length);
          return t.copy(e), e;
        }(t, r);

        if (F == g || F == i || P && !h) {
          if ($(t)) return h ? t : {};
          if (T = function (t) {
            return "function" != typeof t.constructor || qt(t) ? {} : (r = st(t), Gt(r) ? ut(r) : {});
            var r;
          }(P ? {} : t), !r) return function (t, r) {
            return Nt(t, xt(t), r);
          }(t, function (t, r) {
            return t && Nt(r, Qt(r), t);
          }(T, t));
        } else {
          if (!L[F]) return h ? t : {};

          T = function (t, r, e, n) {
            var o = t.constructor;

            switch (r) {
              case b:
                return Dt(t);

              case a:
              case s:
                return new o(+t);

              case w:
                return function (t, r) {
                  var e = r ? Dt(t.buffer) : t.buffer;
                  return new t.constructor(e, t.byteOffset, t.byteLength);
                }(t, n);

              case _:
              case O:
              case j:
              case A:
              case I:
              case E:
              case M:
              case W:
              case R:
                return function (t, r) {
                  var e = r ? Dt(t.buffer) : t.buffer;
                  return new t.constructor(e, t.byteOffset, t.length);
                }(t, n);

              case f:
                return function (t, r, e) {
                  return q(r ? e(U(t), !0) : U(t), H, new t.constructor());
                }(t, n, e);

              case l:
              case m:
                return new o(t);

              case p:
                return function (t) {
                  var r = new t.constructor(t.source, C.exec(t));
                  return r.lastIndex = t.lastIndex, r;
                }(t);

              case y:
                return function (t, r, e) {
                  return q(r ? e(Z(t), !0) : Z(t), J, new t.constructor());
                }(t, n, e);

              case d:
                return i = t, It ? Object(It.call(i)) : {};
            }

            var i;
          }(t, F, Lt, r);
        }
      }

      v || (v = new Rt());
      var D = v.get(t);
      if (D) return D;
      if (v.set(t, T), !S) var N = e ? function (t) {
        return function (t, r, e) {
          var n = r(t);
          return zt(t) ? n : function (t, r) {
            for (var e = -1, n = r.length, o = t.length; ++e < n;) {
              t[o + e] = r[e];
            }

            return t;
          }(n, e(t));
        }(t, Qt, xt);
      }(t) : Qt(t);
      return function (t, r) {
        for (var e = -1, n = t ? t.length : 0; ++e < n && !1 !== r(t[e], e, t);) {
          ;
        }
      }(N || t, function (o, i) {
        N && (o = t[i = o]), St(T, i, Lt(o, r, e, n, i, t, v));
      }), T;
    }

    function Pt(t) {
      return !(!Gt(t) || function (t) {
        return !!Y && Y in t;
      }(t)) && (Vt(t) || $(t) ? nt : S).test($t(t));
    }

    function Dt(t) {
      var r = new t.constructor(t.byteLength);
      return new at(r).set(new at(t)), r;
    }

    function Nt(t, r, e, n) {
      e || (e = {});

      for (var o = -1, i = r.length; ++o < i;) {
        var a = r[o],
            s = n ? n(e[a], t[a], a, e, t) : void 0;
        St(e, a, void 0 === s ? t[a] : s);
      }

      return e;
    }

    function kt(t, e) {
      var n,
          o,
          i = t.__data__;
      return ("string" == (o = r(n = e)) || "number" == o || "symbol" == o || "boolean" == o ? "__proto__" !== n : null === n) ? i["string" == typeof e ? "string" : "hash"] : i.map;
    }

    function Bt(t, r) {
      var e = function (t, r) {
        return null == t ? void 0 : t[r];
      }(t, r);

      return Pt(e) ? e : void 0;
    }

    Et.prototype.clear = function () {
      this.__data__ = bt ? bt(null) : {};
    }, Et.prototype.delete = function (t) {
      return this.has(t) && delete this.__data__[t];
    }, Et.prototype.get = function (t) {
      var r = this.__data__;

      if (bt) {
        var e = r[t];
        return e === n ? void 0 : e;
      }

      return rt.call(r, t) ? r[t] : void 0;
    }, Et.prototype.has = function (t) {
      var r = this.__data__;
      return bt ? void 0 !== r[t] : rt.call(r, t);
    }, Et.prototype.set = function (t, r) {
      return this.__data__[t] = bt && void 0 === r ? n : r, this;
    }, Mt.prototype.clear = function () {
      this.__data__ = [];
    }, Mt.prototype.delete = function (t) {
      var r = this.__data__,
          e = Ft(r, t);
      return !(e < 0) && (e == r.length - 1 ? r.pop() : ft.call(r, e, 1), !0);
    }, Mt.prototype.get = function (t) {
      var r = this.__data__,
          e = Ft(r, t);
      return e < 0 ? void 0 : r[e][1];
    }, Mt.prototype.has = function (t) {
      return Ft(this.__data__, t) > -1;
    }, Mt.prototype.set = function (t, r) {
      var e = this.__data__,
          n = Ft(e, t);
      return n < 0 ? e.push([t, r]) : e[n][1] = r, this;
    }, Wt.prototype.clear = function () {
      this.__data__ = {
        hash: new Et(),
        map: new (yt || Mt)(),
        string: new Et()
      };
    }, Wt.prototype.delete = function (t) {
      return kt(this, t).delete(t);
    }, Wt.prototype.get = function (t) {
      return kt(this, t).get(t);
    }, Wt.prototype.has = function (t) {
      return kt(this, t).has(t);
    }, Wt.prototype.set = function (t, r) {
      return kt(this, t).set(t, r), this;
    }, Rt.prototype.clear = function () {
      this.__data__ = new Mt();
    }, Rt.prototype.delete = function (t) {
      return this.__data__.delete(t);
    }, Rt.prototype.get = function (t) {
      return this.__data__.get(t);
    }, Rt.prototype.has = function (t) {
      return this.__data__.has(t);
    }, Rt.prototype.set = function (t, r) {
      var e = this.__data__;

      if (e instanceof Mt) {
        var n = e.__data__;
        if (!yt || n.length < 199) return n.push([t, r]), this;
        e = this.__data__ = new Wt(n);
      }

      return e.set(t, r), this;
    };

    var xt = lt ? z(lt, Object) : function () {
      return [];
    },
        Ht = function Ht(t) {
      return et.call(t);
    };

    function Jt(t, r) {
      return !!(r = null == r ? o : r) && ("number" == typeof t || F.test(t)) && t > -1 && t % 1 == 0 && t < r;
    }

    function qt(t) {
      var r = t && t.constructor;
      return t === ("function" == typeof r && r.prototype || Q);
    }

    function $t(t) {
      if (null != t) {
        try {
          return tt.call(t);
        } catch (t) {}

        try {
          return t + "";
        } catch (t) {}
      }

      return "";
    }

    function Ut(t, r) {
      return t === r || t != t && r != r;
    }

    (pt && Ht(new pt(new ArrayBuffer(1))) != w || yt && Ht(new yt()) != f || mt && Ht(mt.resolve()) != h || dt && Ht(new dt()) != y || vt && Ht(new vt()) != v) && (Ht = function Ht(t) {
      var r = et.call(t),
          e = r == g ? t.constructor : void 0,
          n = e ? $t(e) : void 0;
      if (n) switch (n) {
        case wt:
          return w;

        case _t:
          return f;

        case Ot:
          return h;

        case Tt:
          return y;

        case jt:
          return v;
      }
      return r;
    });
    var zt = Array.isArray;

    function Zt(t) {
      return null != t && function (t) {
        return "number" == typeof t && t > -1 && t % 1 == 0 && t <= o;
      }(t.length) && !Vt(t);
    }

    var Kt = gt || function () {
      return !1;
    };

    function Vt(t) {
      var r = Gt(t) ? et.call(t) : "";
      return r == u || r == c;
    }

    function Gt(t) {
      var e = r(t);
      return !!t && ("object" == e || "function" == e);
    }

    function Qt(t) {
      return Zt(t) ? Ct(t) : function (t) {
        if (!qt(t)) return ht(t);
        var r = [];

        for (var e in Object(t)) {
          rt.call(t, e) && "constructor" != e && r.push(e);
        }

        return r;
      }(t);
    }

    t.exports = function (t) {
      return Lt(t, !0, !0);
    };
  });

  function j(t, r) {
    return function (t, r, e) {
      if ("string" != typeof t || !t.length) return null;
      if (r && "number" == typeof r || (r = 0), !t[r + 1]) return null;
      if (t[r + 1] && (!e && t[r + 1].trim() || e && (t[r + 1].trim() || "\n\r".includes(t[r + 1])))) return r + 1;
      if (t[r + 2] && (!e && t[r + 2].trim() || e && (t[r + 2].trim() || "\n\r".includes(t[r + 2])))) return r + 2;

      for (var n = r + 1, o = t.length; n < o; n++) {
        if (t[n] && (!e && t[n].trim() || e && (t[n].trim() || "\n\r".includes(t[n])))) return n;
      }

      return null;
    }(t, r, !1);
  }

  function A(t, r) {
    return function (t, r, e) {
      if ("string" != typeof t || !t.length) return null;
      if (r && "number" == typeof r || (r = 0), r < 1) return null;
      if (t[~-r] && (!e && t[~-r].trim() || e && (t[~-r].trim() || "\n\r".includes(t[~-r])))) return ~-r;
      if (t[r - 2] && (!e && t[r - 2].trim() || e && (t[r - 2].trim() || "\n\r".includes(t[r - 2])))) return r - 2;

      for (var n = r; n--;) {
        if (t[n] && (!e && t[n].trim() || e && (t[n].trim() || "\n\r".includes(t[n])))) return n;
      }

      return null;
    }(t, r, !1);
  }

  var I = " ";

  function E(t) {
    var r = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : 1;

    function e(t) {
      return Array.from(t).reverse().join("");
    }

    function n(t, r, e) {
      var n = e ? "\n" : "\r",
          o = e ? "\r" : "\n";
      if (!t) return t;

      for (var i = 0, a = "", s = 0, u = t.length; s < u; s++) {
        (t[s] === n || t[s] === o && t[s - 1] !== n) && i++, "\r\n".includes(t[s]) || t[s] === I ? t[s] === I ? a += t[s] : t[s] === n ? i <= r && (a += t[s], t[s + 1] === o && (a += t[s + 1], s++)) : t[s] === o && (!t[s - 1] || t[s - 1] !== n) && i <= r && (a += t[s]) : t[s + 1] || i || (a += " ");
      }

      return a;
    }

    if ("string" == typeof t && t.length) {
      var o = 1;
      "number" == typeof +r && Number.isInteger(+r) && +r >= 0 && (o = +r);
      var i = "",
          a = "";

      if (t.trim()) {
        if (!t[0].trim()) for (var s = 0, u = t.length; s < u; s++) {
          if (t[s].trim()) {
            i = t.slice(0, s);
            break;
          }
        }
      } else i = t;

      if (t.trim() && ("" === t.slice(-1).trim() || t.slice(-1) === I)) for (var c = t.length; c--;) {
        if (t[c].trim()) {
          a = t.slice(c + 1);
          break;
        }
      }
      return "".concat(n(i, o, !1)).concat(t.trim()).concat(e(n(e(a), o, !0)));
    }

    return t;
  }

  function M(t, r) {
    if (!Array.isArray(t) || !t.length) return t;
    var e,
        n,
        o = i(i({}, {
      strictlyTwoElementsInRangeArrays: !1,
      progressFn: null
    }), r);
    if (o.strictlyTwoElementsInRangeArrays && !t.filter(function (t) {
      return t;
    }).every(function (t, r) {
      return 2 === t.length || (e = r, n = t.length, !1);
    })) throw new TypeError("ranges-sort: [THROW_ID_03] The first argument should be an array and must consist of arrays which are natural number indexes representing TWO string index ranges. However, ".concat(e, "th range (").concat(JSON.stringify(t[e], null, 4), ") has not two but ").concat(n, " elements!"));
    if (!t.filter(function (t) {
      return t;
    }).every(function (t, r) {
      return !(!Number.isInteger(t[0]) || t[0] < 0 || !Number.isInteger(t[1]) || t[1] < 0) || (e = r, !1);
    })) throw new TypeError("ranges-sort: [THROW_ID_04] The first argument should be an array and must consist of arrays which are natural number indexes representing string index ranges. However, ".concat(e, "th range (").concat(JSON.stringify(t[e], null, 4), ") does not consist of only natural numbers!"));
    var a = Math.pow(t.filter(function (t) {
      return t;
    }).length, 2),
        s = 0;
    return Array.from(t).filter(function (t) {
      return t;
    }).sort(function (t, r) {
      return o.progressFn && (s += 1, o.progressFn(Math.floor(100 * s / a))), t[0] === r[0] ? t[1] < r[1] ? -1 : t[1] > r[1] ? 1 : 0 : t[0] < r[0] ? -1 : 1;
    });
  }

  function W(t, e) {
    function n(t) {
      return "string" == typeof t;
    }

    function o(t) {
      return t && "object" === r(t) && !Array.isArray(t);
    }

    if (!Array.isArray(t) || !t.length) return null;
    var s,
        u = {
      mergeType: 1,
      progressFn: null,
      joinRangesThatTouchEdges: !0
    };

    if (e) {
      if (!o(e)) throw new Error("emlint: [THROW_ID_03] the second input argument must be a plain object. It was given as:\n".concat(JSON.stringify(e, null, 4), " (type ").concat(r(e), ")"));
      if ((s = i(i({}, u), e)).progressFn && o(s.progressFn) && !Object.keys(s.progressFn).length) s.progressFn = null;else if (s.progressFn && "function" != typeof s.progressFn) throw new Error('ranges-merge: [THROW_ID_01] opts.progressFn must be a function! It was given of a type: "'.concat(r(s.progressFn), '", equal to ').concat(JSON.stringify(s.progressFn, null, 4)));
      if (s.mergeType && 1 !== s.mergeType && 2 !== s.mergeType) if (n(s.mergeType) && "1" === s.mergeType.trim()) s.mergeType = 1;else {
        if (!n(s.mergeType) || "2" !== s.mergeType.trim()) throw new Error('ranges-merge: [THROW_ID_02] opts.mergeType was customised to a wrong thing! It was given of a type: "'.concat(r(s.mergeType), '", equal to ').concat(JSON.stringify(s.mergeType, null, 4)));
        s.mergeType = 2;
      }
      if ("boolean" != typeof s.joinRangesThatTouchEdges) throw new Error('ranges-merge: [THROW_ID_04] opts.joinRangesThatTouchEdges was customised to a wrong thing! It was given of a type: "'.concat(r(s.joinRangesThatTouchEdges), '", equal to ').concat(JSON.stringify(s.joinRangesThatTouchEdges, null, 4)));
    } else s = i({}, u);

    for (var c, f, l, g = t.filter(function (t) {
      return t;
    }).map(function (t) {
      return a(t);
    }).filter(function (t) {
      return void 0 !== t[2] || t[0] !== t[1];
    }), h = (c = s.progressFn ? M(g, {
      progressFn: function progressFn(t) {
        (l = Math.floor(t / 5)) !== f && (f = l, s.progressFn(l));
      }
    }) : M(g)).length - 1, p = h; p > 0; p--) {
      s.progressFn && (l = Math.floor(78 * (1 - p / h)) + 21) !== f && l > f && (f = l, s.progressFn(l)), (c[p][0] <= c[p - 1][0] || !s.joinRangesThatTouchEdges && c[p][0] < c[p - 1][1] || s.joinRangesThatTouchEdges && c[p][0] <= c[p - 1][1]) && (c[p - 1][0] = Math.min(c[p][0], c[p - 1][0]), c[p - 1][1] = Math.max(c[p][1], c[p - 1][1]), void 0 !== c[p][2] && (c[p - 1][0] >= c[p][0] || c[p - 1][1] <= c[p][1]) && null !== c[p - 1][2] && (null === c[p][2] && null !== c[p - 1][2] ? c[p - 1][2] = null : void 0 !== c[p - 1][2] ? 2 === s.mergeType && c[p - 1][0] === c[p][0] ? c[p - 1][2] = c[p][2] : c[p - 1][2] += c[p][2] : c[p - 1][2] = c[p][2]), c.splice(p, 1), p = c.length);
    }

    return c.length ? c : null;
  }

  function R(t) {
    return null != t;
  }

  function C(t) {
    return Number.isInteger(t) && t >= 0;
  }

  function S(t) {
    return "string" == typeof t;
  }

  function F(t) {
    return /^\d*$/.test(t) ? parseInt(t, 10) : t;
  }

  var L = function () {
    function t(e) {
      !function (t, r) {
        if (!(t instanceof r)) throw new TypeError("Cannot call a class as a function");
      }(this, t);
      var n = i(i({}, {
        limitToBeAddedWhitespace: !1,
        limitLinebreaksCount: 1,
        mergeType: 1
      }), e);
      if (n.mergeType && 1 !== n.mergeType && 2 !== n.mergeType) if (S(n.mergeType) && "1" === n.mergeType.trim()) n.mergeType = 1;else {
        if (!S(n.mergeType) || "2" !== n.mergeType.trim()) throw new Error('ranges-push: [THROW_ID_02] opts.mergeType was customised to a wrong thing! It was given of a type: "'.concat(r(n.mergeType), '", equal to ').concat(JSON.stringify(n.mergeType, null, 4)));
        n.mergeType = 2;
      }
      this.opts = n;
    }

    var n, o, s;
    return n = t, (o = [{
      key: "add",
      value: function value(t, e, n) {
        for (var o = this, i = arguments.length, s = new Array(i > 3 ? i - 3 : 0), u = 3; u < i; u++) {
          s[u - 3] = arguments[u];
        }

        if (s.length > 0) throw new TypeError("ranges-push/Ranges/add(): [THROW_ID_03] Please don't overload the add() method. From the 4th input argument onwards we see these redundant arguments: ".concat(JSON.stringify(s, null, 4)));

        if (R(t) || R(e)) {
          if (R(t) && !R(e)) {
            if (Array.isArray(t)) {
              if (t.length) {
                if (t.some(function (t) {
                  return Array.isArray(t);
                })) return void t.forEach(function (t) {
                  Array.isArray(t) && o.add.apply(o, a(t));
                });
                t.length > 1 && C(F(t[0])) && C(F(t[1])) && this.add.apply(this, a(t));
              }

              return;
            }

            throw new TypeError('ranges-push/Ranges/add(): [THROW_ID_12] the first input argument, "from" is set ('.concat(JSON.stringify(t, null, 0), ') but second-one, "to" is not (').concat(JSON.stringify(e, null, 0), ")"));
          }

          if (!R(t) && R(e)) throw new TypeError('ranges-push/Ranges/add(): [THROW_ID_13] the second input argument, "to" is set ('.concat(JSON.stringify(e, null, 0), ') but first-one, "from" is not (').concat(JSON.stringify(t, null, 0), ")"));
          var c = /^\d*$/.test(t) ? parseInt(t, 10) : t,
              f = /^\d*$/.test(e) ? parseInt(e, 10) : e;
          if (C(n) && (n = String(n)), !C(c) || !C(f)) throw C(c) && c >= 0 ? new TypeError('ranges-push/Ranges/add(): [THROW_ID_10] "to" value, the second input argument, must be a natural number or zero! Currently it\'s of a type "'.concat(r(f), '" equal to: ').concat(JSON.stringify(f, null, 4))) : new TypeError('ranges-push/Ranges/add(): [THROW_ID_09] "from" value, the first input argument, must be a natural number or zero! Currently it\'s of a type "'.concat(r(c), '" equal to: ').concat(JSON.stringify(c, null, 4)));
          if (R(n) && !S(n) && !C(n)) throw new TypeError("ranges-push/Ranges/add(): [THROW_ID_08] The third argument, the value to add, was given not as string but ".concat(r(n), ", equal to:\n").concat(JSON.stringify(n, null, 4)));

          if (R(this.ranges) && Array.isArray(this.last()) && c === this.last()[1]) {
            if (this.last()[1] = f, this.last()[2], null !== this.last()[2] && R(n)) {
              var l = !(R(this.last()[2]) && this.last()[2].length > 0) || this.opts && this.opts.mergeType && 1 !== this.opts.mergeType ? n : this.last()[2] + n;
              this.opts.limitToBeAddedWhitespace && (l = E(l, this.opts.limitLinebreaksCount)), S(l) && !l.length || (this.last()[2] = l);
            }
          } else {
            this.ranges || (this.ranges = []);
            var g = void 0 === n || S(n) && !n.length ? [c, f] : [c, f, this.opts.limitToBeAddedWhitespace ? E(n, this.opts.limitLinebreaksCount) : n];
            this.ranges.push(g);
          }
        }
      }
    }, {
      key: "push",
      value: function value(t, r, e) {
        for (var n = arguments.length, o = new Array(n > 3 ? n - 3 : 0), i = 3; i < n; i++) {
          o[i - 3] = arguments[i];
        }

        this.add.apply(this, [t, r, e].concat(o));
      }
    }, {
      key: "current",
      value: function value() {
        var t = this;
        return null != this.ranges ? (this.ranges = W(this.ranges, {
          mergeType: this.opts.mergeType
        }), this.ranges && this.opts.limitToBeAddedWhitespace ? this.ranges.map(function (r) {
          return R(r[2]) ? [r[0], r[1], E(r[2], t.opts.limitLinebreaksCount)] : r;
        }) : this.ranges) : null;
      }
    }, {
      key: "wipe",
      value: function value() {
        this.ranges = void 0;
      }
    }, {
      key: "replace",
      value: function value(t) {
        if (Array.isArray(t) && t.length) {
          if (!Array.isArray(t[0]) || !C(t[0][0])) throw new Error("ranges-push/Ranges/replace(): [THROW_ID_11] Single range was given but we expected array of arrays! The first element, ".concat(JSON.stringify(t[0], null, 4), " should be an array and its first element should be an integer, a string index."));
          this.ranges = Array.from(t);
        } else this.ranges = void 0;
      }
    }, {
      key: "last",
      value: function value() {
        return void 0 !== this.ranges && Array.isArray(this.ranges) ? this.ranges[this.ranges.length - 1] : null;
      }
    }]) && e(n.prototype, o), s && e(n, s), t;
  }();

  function P(t) {
    return null != t;
  }

  function D(t) {
    return "string" == typeof t;
  }

  function N(t, e, n) {
    var o,
        i = 0,
        a = 0;
    if (0 === arguments.length) throw new Error("ranges-apply: [THROW_ID_01] inputs missing!");
    if (!D(t)) throw new TypeError("ranges-apply: [THROW_ID_02] first input argument must be a string! Currently it's: ".concat(r(t), ", equal to: ").concat(JSON.stringify(t, null, 4)));
    if (e && !Array.isArray(e)) throw new TypeError("ranges-apply: [THROW_ID_03] second input argument must be an array (or null)! Currently it's: ".concat(r(e), ", equal to: ").concat(JSON.stringify(e, null, 4)));
    if (n && "function" != typeof n) throw new TypeError("ranges-apply: [THROW_ID_04] the third input argument must be a function (or falsey)! Currently it's: ".concat(r(n), ", equal to: ").concat(JSON.stringify(n, null, 4)));
    if (!e || !e.filter(function (t) {
      return t;
    }).length) return t;
    var s = (o = Array.isArray(e) && (Number.isInteger(e[0]) && e[0] >= 0 || /^\d*$/.test(e[0])) && (Number.isInteger(e[1]) && e[1] >= 0 || /^\d*$/.test(e[1])) ? [Array.from(e)] : Array.from(e)).length,
        u = 0;
    o.filter(function (t) {
      return t;
    }).forEach(function (t, e) {
      if (n && (i = Math.floor(u / s * 10)) !== a && (a = i, n(i)), !Array.isArray(t)) throw new TypeError("ranges-apply: [THROW_ID_05] ranges array, second input arg., has ".concat(e, "th element not an array: ").concat(JSON.stringify(t, null, 4), ", which is ").concat(r(t)));

      if (!Number.isInteger(t[0]) || t[0] < 0) {
        if (!/^\d*$/.test(t[0])) throw new TypeError("ranges-apply: [THROW_ID_06] ranges array, second input arg. has ".concat(e, "th element, array [").concat(t[0], ",").concat(t[1], "]. That array has first element not an integer, but ").concat(r(t[0]), ", equal to: ").concat(JSON.stringify(t[0], null, 4), ". Computer doesn't like this."));
        o[e][0] = Number.parseInt(o[e][0], 10);
      }

      if (!Number.isInteger(t[1])) {
        if (!/^\d*$/.test(t[1])) throw new TypeError("ranges-apply: [THROW_ID_07] ranges array, second input arg. has ".concat(e, "th element, array [").concat(t[0], ",").concat(t[1], "]. That array has second element not an integer, but ").concat(r(t[1]), ", equal to: ").concat(JSON.stringify(t[1], null, 4), ". Computer doesn't like this."));
        o[e][1] = Number.parseInt(o[e][1], 10);
      }

      u += 1;
    });
    var c = W(o, {
      progressFn: function progressFn(t) {
        n && (i = 10 + Math.floor(t / 10)) !== a && (a = i, n(i));
      }
    });
    if (!c) return t;
    var f = c.length;

    if (f > 0) {
      var l = t.slice(c[f - 1][1]);
      t = c.reduce(function (r, e, o, s) {
        n && (i = 20 + Math.floor(o / f * 80)) !== a && (a = i, n(i));
        var u = 0 === o ? 0 : s[o - 1][1],
            c = s[o][0];
        return r + t.slice(u, c) + (P(s[o][2]) ? s[o][2] : "");
      }, ""), t += l;
    }

    return t;
  }

  var k = " ",
      B = "&nbsp;",
      x = "\\00A0",
      H = "\\u00A0",
      J = [{
    heads: "{{",
    tails: "}}"
  }, {
    heads: ["{% if", "{%- if"],
    tails: ["{% endif", "{%- endif"]
  }, {
    heads: ["{% for", "{%- for"],
    tails: ["{% endfor", "{%- endfor"]
  }, {
    heads: ["{%", "{%-"],
    tails: ["%}", "-%}"]
  }, {
    heads: "{#",
    tails: "#}"
  }],
      q = [{
    heads: "{{",
    tails: "}}"
  }],
      $ = [{
    heads: ["<%", "<%=", "<%-"],
    tails: ["%>", "=%>", "-%>"]
  }],
      U = ["abbr", "address", "area", "article", "aside", "audio", "base", "bdi", "bdo", "blockquote", "body", "br", "button", "canvas", "caption", "center", "cite", "code", "col", "colgroup", "data", "datalist", "dd", "del", "details", "dfn", "dialog", "div", "dl", "doctype", "dt", "em", "embed", "fieldset", "figcaption", "figure", "footer", "form", "h1", "h2", "h3", "h4", "h5", "h6", "head", "header", "hgroup", "hr", "html", "iframe", "img", "input", "ins", "kbd", "keygen", "label", "legend", "li", "link", "main", "map", "mark", "math", "menu", "menuitem", "meta", "meter", "nav", "noscript", "object", "ol", "optgroup", "option", "output", "param", "picture", "pre", "progress", "rb", "rp", "rt", "rtc", "ruby", "samp", "script", "section", "select", "slot", "small", "source", "span", "strong", "style", "sub", "summary", "sup", "svg", "table", "tbody", "td", "template", "textarea", "tfoot", "th", "thead", "time", "title", "tr", "track", "ul", "var", "video", "wbr", "xml"],
      z = {
    removeWidowPreventionMeasures: !1,
    convertEntities: !0,
    targetLanguage: "html",
    UKPostcodes: !1,
    hyphens: !0,
    minWordCount: 4,
    minCharCount: 5,
    ignore: [],
    reportProgressFunc: null,
    reportProgressFuncFrom: 0,
    reportProgressFuncTo: 100,
    tagRanges: []
  };
  t.defaultOpts = z, t.removeWidows = function (t, e) {
    function n(t) {
      return "string" == typeof t;
    }

    var o = Date.now();
    if (!n(t)) throw void 0 === t ? new Error("string-remove-widows: [THROW_ID_01] the first input argument is completely missing! It should be given as string.") : new Error('string-remove-widows: [THROW_ID_02] the first input argument must be string! It was given as "'.concat(r(t), '", equal to:\n').concat(JSON.stringify(t, null, 4)));
    if (e && !O(e)) throw new Error("string-remove-widows: [THROW_ID_03] the second input argument, options object, should be a plain object but it was given as type ".concat(r(e), ", equal to ").concat(JSON.stringify(e, null, 4)));
    var a,
        s,
        c,
        f,
        l,
        h,
        p,
        y,
        m,
        d,
        v,
        b,
        w = Array.isArray,
        _ = t.length,
        T = new L({
      mergeType: 2
    }),
        I = ["."],
        E = /[A-Z]{1,2}[0-9][0-9A-Z]?$/,
        M = /^[0-9][A-Z]{2}/,
        W = .06,
        R = 0,
        C = i(i({}, z), e),
        S = {
      removeWidows: !1,
      convertEntities: !1
    };

    if (C.dashes && (C.hyphens = !0, delete C.dashes), C.ignore && (w(C.ignore) || n(C.ignore))) {
      if (C.ignore = u(C.ignore), C.ignore.includes("all")) C.ignore = C.ignore.concat(J.concat($));else if (C.ignore.some(function (t) {
        return n(t);
      })) {
        var F = [];
        C.ignore = C.ignore.filter(function (t) {
          return n(t) && t.length ? (["nunjucks", "jinja", "liquid"].includes(t.trim().toLowerCase()) ? F = F.concat(J) : ["hugo"].includes(t.trim().toLowerCase()) ? F = F.concat(q) : ["hexo"].includes(t.trim().toLowerCase()) && (F = F.concat($)), !1) : "object" === r(t) || void 0;
        }), F.length && (C.ignore = C.ignore.concat(F));
      }
    } else C.ignore = [];

    function P(r, e) {
      var o = k;
      C.removeWidowPreventionMeasures ? o = " " : C.convertEntities && (o = B, n(C.targetLanguage) && ("css" === C.targetLanguage.trim().toLowerCase() ? o = x : "js" === C.targetLanguage.trim().toLowerCase() && (o = H))), t.slice(r, e) !== o && T.push(r, e, o);
    }

    function D() {
      s = 0, c = 0, f = void 0, l = void 0, h = void 0, p = void 0, y = void 0, m = void 0;
    }

    C.reportProgressFunc && (b = Math.floor(C.reportProgressFuncTo - (C.reportProgressFuncTo - C.reportProgressFuncFrom) * W - C.reportProgressFuncFrom)), D();

    for (var Z = function Z(r) {
      if (!d && w(C.ignore) && C.ignore.length && C.ignore.some(function (e, o) {
        if (w(e.heads) && e.heads.some(function (e) {
          return t.startsWith(e, r);
        }) || n(e.heads) && t.startsWith(e.heads, r)) return s += 1, d = C.ignore[o].tails, K = r, !0;
      }), !d && v && v === r && (s += 1, v = void 0), "function" == typeof C.reportProgressFunc && (a = C.reportProgressFuncFrom + Math.floor(r / _ * b)) !== R && (R = a, C.reportProgressFunc(a)), !d && r && t[r] && t[r].trim() && (!t[r - 1] || t[r - 1] && !t[r - 1].trim()) && (p = r), !d && t[r] && t[r].trim() && (c += 1), d || !C.hyphens || !("-".concat("—").concat("–").includes(t[r]) || t.startsWith("&ndash;", r) || t.startsWith("\\2013", r) || t.startsWith("\\u2013", r) || t.startsWith("&mdash;", r) || t.startsWith("\\2014", r) || t.startsWith("\\u2014", r)) || !t[r + 1] || t[r + 1].trim() && "&" !== t[r] || t[r - 1] && !t[r - 1].trim() && t[A(t, r)] && (P(A(t, r) + 1, r), S.removeWidows = !0), d || !t.startsWith("&nbsp;", r) && !t.startsWith("&#160;", r) || (y = r, m = r + 6, t[r + 6] && t[r + 6].trim() && (v = r + 6), C.convertEntities ? "css" !== C.targetLanguage && "js" !== C.targetLanguage || (T.push(r, r + 6, "css" === C.targetLanguage ? x : H), S.convertEntities = !0) : (T.push(r, r + 6, k), S.convertEntities = !0)), !d && t[r + 4] && "\\" === t[r] && "0" === t[r + 1] && "0" === t[r + 2] && "A" === t[r + 3].toUpperCase() && "0" === t[r + 4] && (y = r, m = r + 5, t[r + 5] && t[r + 5].trim() && (v = r + 5), C.convertEntities ? "html" !== C.targetLanguage && "js" !== C.targetLanguage || (T.push(r, r + 5, "html" === C.targetLanguage ? B : H), S.convertEntities = !0) : (T.push(r, r + 5, k), S.convertEntities = !0)), !d && "\\" === t[r] && t[r + 1] && "u" === t[r + 1].toLowerCase() && "0" === t[r + 2] && "0" === t[r + 3] && t[r + 4] && "A" === t[r + 4].toUpperCase() && "0" === t[r + 5] && (y = r, m = r + 6, t[r + 6] && t[r + 6].trim() && (v = r + 6), C.convertEntities ? "html" !== C.targetLanguage && "css" !== C.targetLanguage || T.push(r, r + 6, "html" === C.targetLanguage ? B : x) : T.push(r, r + 6, k)), d || t[r] !== k || (y = r, m = r + 1, t[r + 2] && t[r + 2].trim() && (v = r + 2), C.convertEntities && T.push(r, r + 1, "css" === C.targetLanguage ? x : "js" === C.targetLanguage ? H : B)), d || !t[r] || !t[r].trim() || t[r - 1] && t[r - 1].trim() || (s += 1), !d && (!t[r] || "\r\n".includes(t[r]) || ("\n" === t[r] || "\r" === t[r] || "\r" === t[r] && "\n" === t[r + 1]) && t[r - 1] && I.includes(t[A(t, r)]))) {
        var e, o;
        if ((!C.minWordCount || s >= C.minWordCount) && (!C.minCharCount || c >= C.minCharCount)) void 0 !== h && void 0 !== p && void 0 !== y && void 0 !== m ? h > y ? (e = h, o = p) : (e = y, o = m) : void 0 !== h && void 0 !== p ? (e = h, o = p) : void 0 !== y && void 0 !== m && (e = y, o = m), e && o || !f || !l || (e = f, o = l), e && o && (P(e, o), S.removeWidows = !0);
        D();
      }

      C.UKPostcodes && t[r] && !t[r].trim() && t[r - 1] && t[r - 1].trim() && E.test(t.slice(0, r)) && t[j(t, r)] && M.test(t.slice(j(t, r))) && (P(r, j(t, r)), S.removeWidows = !0), d || !t[r] || t[r].trim() || !t[r - 1] || !t[r - 1].trim() || !(void 0 === h || t[h - 1] && t[h - 1].trim()) || "/>".includes(t[j(t, r)]) || t.slice(0, r).trim().endsWith("br") || t.slice(0, r).trim().endsWith("hr") || t.slice(0, r).endsWith("<") && U.some(function (e) {
        return t.startsWith(e, j(t, r));
      }) || (f = h, l = p, h = r, p = void 0, void 0 === y && void 0 === m || (y = void 0, m = void 0));
      var i = void 0;
      d && (!n(d) || d.length && !t.startsWith(d, r) ? !w(d) || d.length && !d.some(function (e) {
        if (t.startsWith(e, r)) return i = e, K = r, !0;
      }) || (d = void 0, r += i.length, w(C.ignore) && C.ignore.length && t[r + 1] && C.ignore.some(function (e) {
        return K = r, g(t, r, e.tails, {
          trimBeforeMatching: !0,
          cb: function cb(e, n, o) {
            return o && t[(r = o - 1) + 1] && t[r + 1].trim() && (s += 1), K = r, !0;
          }
        });
      })) : d = void 0), t[r] && "\r\n".includes(t[r]) && (s = 0, c = 0), w(C.tagRanges) && C.tagRanges.length && C.tagRanges.some(function (t) {
        if (r >= t[0] && r <= t[1] && t[1] - 1 > r) return r = t[1] - 1, K = r, !0;
      }), K = r;
    }, K = 0; K <= _; K++) {
      Z(K);
    }

    return {
      res: N(t, T.current(), C.reportProgressFunc ? function (t) {
        (a = Math.floor(.94 * (C.reportProgressFuncTo - C.reportProgressFuncFrom) + t / 100 * (C.reportProgressFuncTo - C.reportProgressFuncFrom) * W)) !== R && (R = a, C.reportProgressFunc(a));
      } : null),
      ranges: T.current(),
      log: {
        timeTakenInMiliseconds: Date.now() - o
      },
      whatWasDone: S
    };
  }, t.version = "1.6.17", Object.defineProperty(t, "__esModule", {
    value: !0
  });
});